// Vouchers Store

const state = {
  vouchers: [],
  pending: false,
  error: null,
}

const getters = {
  isPending: ({ pending }) => pending,
}

const actions = {
  // getVouchers({ commit }) {
  //   return new Promise(resolve => {
  //     commit('SET_PENDING')
  //     commit('REMOVE_ERROR')
  //     this.http.get('get_vouchers_test').then(({ data }) => {
  //       if (data.type === 1) {
  //         commit('SET_VOUCHERS', data.vouchers)
  //       }
  //       commit('SET_PENDING')
  //       resolve()
  //     })
  //   })
  // },
  addVoucher({ commit }, payload) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      commit('REMOVE_ERROR')
      this.api.items.createItem('carts.mine.vouchers', {
        voucher_code: payload,
      })
      .then(({ data }) => {
        if (data.type === 1) {
          commit('ADD_VOUCHER', data)
        } else {
          commit('SET_ERROR', data)
        }
        commit('SET_PENDING')
        resolve(data)
      })
    })
  },
  removeVoucher({ commit }, payload) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      commit('REMOVE_ERROR')
      this.api.items.deleteItem(`carts.mine.vouchers.${payload.id}`).then(({ data }) => {
        commit('REMOVE_VOUCHER', payload)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  SET_VOUCHERS: (state, payload) => {
    state.vouchers = payload
  },
  SET_ERROR: (state, payload) => {
    state.error = payload
  },
  REMOVE_ERROR: state => {
    state.error = null
  },
  ADD_VOUCHER: (state, payload) => {
    state.vouchers.push(payload)
  },
  REMOVE_VOUCHER: (state, payload) => {
    state.vouchers.splice(state.vouchers.indexOf(payload), 1)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
